<template>
    <modal
        name="resource-subscribe"
        height="auto"
    >
        <modal-skeleton>
            <template slot="heading">
                <template v-if="!subscribed">
                    Subscribe to Resource
                </template>
                <template v-else>
                    Unsubscribe from Resource
                </template>
            </template>
            <template v-if="!subscribed">
                <p>To receive email notifications when this resource is updated, click the subscribe button below.</p>
            </template>
            <template v-else>
                <p>
                    You are currently receiving email notifications when this resource is updated. Click the
                    unsubscribe button below to stop them.
                </p>
            </template>
            <template slot="footer">
                <template v-if="!subscribed">
                    <button
                        class="button -outline -square"
                        @click="handleClose"
                    >
                        {{ secondaryButtonText }}
                    </button>
                    <button
                        class="button -blue -square"
                        :class="buttonState === 'success' ? '-success' : ''"
                        @click="toggleSubscribe"
                    >
                        {{ primaryButtonText }}
                    </button>
                </template>

                <template v-if="subscribed">
                    <button
                        class="button -outline -square"
                        @click="toggleSubscribe"
                    >
                        {{ secondaryButtonText }}
                    </button>
                    <button
                        class="button -blue -square"
                        @click="handleClose"
                    >
                        {{ primaryButtonText }}
                    </button>
                </template>
            </template>
        </modal-skeleton>
    </modal>
</template>

<script>
import EventBus from '../EventBus';
import ModalSkeleton from './ModalSkeleton.vue';

export default {
    name: 'ResourceSubscribeModal',
    components: {
        ModalSkeleton,
    },
    props: {
        resourceId: {
            type: String,
            required: true,
        },
        isSubscribed: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            subscribed: false,
            primaryButtonText: 'Subscribe',
            secondaryButtonText: 'Cancel',
            buttonState: 'none',
        };
    },
    mounted() {
        if (this.isSubscribed) {
            this.subscribed = true;
            this.primaryButtonText = 'OK';
            this.secondaryButtonText = 'Unsubscribe';
        }
    },
    methods: {
        handleClose() {
            this.$modal.hide('resource-subscribe');
        },
        toggleSubscribe() {
            axios.post('/api/resource-subscriptions/toggle', {
                resource_id: this.resourceId,
            }).then((response) => {
                if (response.data.isSubscribed) {
                    this.primaryButtonText = 'Subscribed';
                    this.buttonState = 'success';
                    EventBus.$emit('resource-subscribe');
                    setTimeout(() => {
                        this.handleClose();
                        this.subscribed = true;
                        this.primaryButtonText = 'OK';
                        this.secondaryButtonText = 'Unsubscribe';
                        this.buttonState = 'none';
                    }, 1500);
                }

                if (!response.data.isSubscribed) {
                    this.handleClose();
                    this.subscribed = false;
                    this.primaryButtonText = 'Subscribe';
                    this.secondaryButtonText = 'Cancel';
                    EventBus.$emit('resource-unsubscribe');
                }
            });
        },
    },
};
</script>
